<template>
	<div id="so-title-bar" class="header-top responsive-item" :class="transparent ? 'bg-transparent border-0':'bg-white'">
		<div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
			<div class="header-top--left">
				<div class="header-item" v-if="type">
					<img src="../../../assets/icons/back-blue.svg"
					     alt=""
					     v-if="type === 'back'"
					     @click="back"
					>
					<img src="../../../assets/icons/closeblue.svg"
					     alt=""
					     v-if="type === 'close' && !transparent"
					     @click="back"
					>
          <img src="../../../assets/icons/close-white.svg"
               alt=""
               v-if="type === 'close' && transparent"
               @click="back"
          >
				</div>
			</div>
			<div class="header-top--middle f-cont f-16 f-bold" :class="{'f-c-white':transparent}">
				{{ pageTitle }}
			</div>
			<div class="header-top--right">
				<div class="header-item">
					<img src="../../../assets/icons/search.svg" alt="" v-if="showSearch" @click="search">
                    <img src="../../../assets/icons/trash-red.svg" alt="" v-if="showDelete" @click="deleteBtn">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTitleBar",
	props: {
		pageTitle: String,
		showSearch: Boolean,
		type: String,
        showDelete: Boolean,
    transparent: Boolean
	},
  mounted() {
    let navBtn = document.getElementById("nav-bottom");
    if (navBtn && navBtn.classList.length > 0) {
      document.getElementById("so-title-bar").classList.add("set-responsive");
    }
  },
	methods: {
		back(payload) {
			this.$emit("back", payload)
		},
		search(payload) {
			this.$emit("search", payload)
		},
        deleteBtn(payload) {
            this.$emit("delete", payload)
        },
	}
}
</script>

<style scoped>
.header-top {
	z-index: 99 !important;
}

@media (min-width: 768px) {
    .set-responsive {
        padding-left: 350px;
    }
}
</style>